<template>
	<router-view />
</template>

<script setup></script>

<style lang="scss">
@import 'style.scss';
</style>
